<template>
  <page-scaffold>
    <card-content :is-loading="isLoading" name="Автоплатеж">
      <div class="autopayment-page" v-if="!isLoading">
        <div class="autopayment-icon" aria-hidden="true">
          <svg viewBox="0 0 100 100">
            <g fill="currentColor">
              <path d="M69.8,15.1V8a4,4,0,1,0-8,0v7H38.2V8a4,4,0,1,0-8,0v7.1C15.9,16.6,9.9,24.1,8.8,36.8a3.2,3.2,0,0,0,3.2,3.5H88a3.2,3.2,0,0,0,3.2-3.5C90.1,24.1,84.1,16.6,69.8,15.1Z"/>
              <path d="M82,43.5H18A6,6,0,0,0,12,49.5V74C12,89.5,19.5,98,35,98H65c15.5,0,23-8.5,23-24V49.5A6,6,0,0,0,82,43.5ZM39.6,77c-.2.2-.5.4-.7.5s-.5.2-.7.3-.5.2-.7.2a3.1,3.1,0,0,1-.8.1,3.6,3.6,0,0,1-2.5-1.1,3.4,3.4,0,0,1-1-2.4,3.3,3.3,0,0,1,1-2.4,3.5,3.5,0,0,1,2.4-1,3.4,3.4,0,0,1,2.4,1,3.4,3.4,0,0,1,0,4.7Zm0-13.8a3.4,3.4,0,0,1-4.8,0,3.4,3.4,0,0,1,0-4.8,3.4,3.4,0,0,1,4.8,0A3.4,3.4,0,0,1,39.6,63.2ZM51,77a3.4,3.4,0,0,1-4.8,0,3.4,3.4,0,0,1,0-4.7,3.4,3.4,0,0,1,4.8,0A3.3,3.3,0,0,1,51,74.6,3.4,3.4,0,0,1,51,77Zm0-13.8a3.4,3.4,0,0,1-4.8,0,3.4,3.4,0,0,1,0-4.8,3.4,3.4,0,0,1,4.8,0A3.4,3.4,0,0,1,51,63.2ZM62.4,77a3.4,3.4,0,0,1-4.8,0,3.4,3.4,0,0,1,0-4.7,3.4,3.4,0,0,1,4.8,0A3.4,3.4,0,0,1,62.4,77Zm0-13.8a3.4,3.4,0,0,1-4.8,0,3.4,3.4,0,0,1,0-4.8,3.4,3.4,0,0,1,4.8,0A3.4,3.4,0,0,1,62.4,63.2Zm16.8,12.5q-.3.5-.6.9a4.4,4.4,0,0,1-.7.7,3.9,3.9,0,0,1-.9.5,3.5,3.5,0,0,1-1,.3,4,4,0,0,1-.9.1,3.7,3.7,0,0,1-2.6-1.1,3.3,3.3,0,0,1-.9-2.4,3.3,3.3,0,0,1,.9-2.4,3.5,3.5,0,0,1,2.4-1,3.6,3.6,0,0,1,2.6,1.1,3.4,3.4,0,0,1,.9,2.4A3.6,3.6,0,0,1,79.2,75.7Z"/>
              <path d="M78.3,59.2A13.5,13.5,0,1,0,91.8,72.7,13.5,13.5,0,0,0,78.3,59.2Zm7.8,14.6-7.5,7a2,2,0,0,1-1.4.5,2,2,0,0,1-1.4-.6l-3.3-3.4a2,2,0,0,1,2.8-2.8l1.9,1.9,6-5.5a2,2,0,0,1,2.7,0A2,2,0,0,1,86.1,73.8Z"/>
            </g>
          </svg>
        </div>
        <h1 class="autopayment-title">{{ titleText }}</h1>
        <p v-if="subtitleText" class="autopayment-subtitle">{{ subtitleText }}</p>
        <button
          v-if="showDisableButton"
          type="button"
          class="autopayment-action"
          :disabled="isActionLoading"
          @click="disableAutopayment"
        >
          Отключить
        </button>
      </div>
    </card-content>
  </page-scaffold>
</template>

<script>
import PageScaffold from "./page-scaffold";
import CardContent from "./card-content";
import axios from "axios";
import {normalizeAutopaymentStatus} from "../utils/autopayment";

export default {
  name: "page-autopayment",
  components: {PageScaffold, CardContent},
  data: () => ({
    isLoading: true,
    status: null,
    error: false,
    errorMessage: null,
    feedback: null,
    isActionLoading: false
  }),
  computed: {
    normalizedStatus() {
      return normalizeAutopaymentStatus(this.status) || (this.error ? 'disabled' : null);
    },
    showDisableButton() {
      return this.normalizedStatus === 'active';
    },
    titleText() {
      if (this.error) {
        return this.errorMessage || "Не удалось загрузить статус услуги";
      }
      if (this.normalizedStatus === 'active') {
        return "Услуга «Автоплатеж» активна";
      }
      if (this.normalizedStatus === 'available') {
        return "Вам доступна услуга «Автоплатеж»";
      }
      if (this.normalizedStatus === 'disabled') {
        return "Услуга «Автоплатеж» недоступна";
      }
      return "Статус услуги неизвестен";
    },
    subtitleText() {
      if (this.feedback) {
        return this.feedback;
      }
      if (this.error) {
        return this.errorMessage || "Попробуйте обновить страницу позже.";
      }
      if (this.normalizedStatus === 'available') {
        return "Подключите автоплатеж для удобного пополнения баланса.";
      }
      return null;
    }
  },
  methods: {
    fetchStatus() {
      this.isLoading = true;
      this.error = false;
      this.errorMessage = null;

      const userID = localStorage.userID;
      if (!userID) {
        this.status = null;
        this.error = true;
        this.errorMessage = "Пользователь не найден";
        this.isLoading = false;
        return Promise.resolve();
      }

      const headers = {Authorization: `Bearer ${localStorage.token}`};

      return axios({
        method: "GET",
        url: "v1/autopayment",
        headers,
        params: {userID}
      }).then(response => {
        const autopaymentResponse = response?.data?.response;
        this.status = autopaymentResponse?.status || null;
      }).catch(() => {
        this.error = true;
        this.errorMessage = "Ошибка запроса";
      }).finally(() => {
        this.isLoading = false;
      });
    },
    disableAutopayment() {
      if (this.isActionLoading || this.normalizedStatus !== 'active') {
        return;
      }

      const userID = localStorage.userID;
      if (!userID) {
        this.error = true;
        this.errorMessage = "Пользователь не найден";
        return;
      }

      const headers = {Authorization: `Bearer ${localStorage.token}`};
      this.isActionLoading = true;
      this.feedback = null;

      axios({
        method: "DELETE",
        url: "v1/autopayment",
        headers,
        params: {userID}
      }).then(response => {
        this.error = false;
        this.errorMessage = null;

        const status = response?.data?.status || null;
        const message = response?.data?.message || null;

        if (status) {
          this.status = status;
        }

        return this.fetchStatus().finally(() => {
          if (message) {
            this.feedback = message;
          }
        });
      }).catch(() => {
        this.error = true;
        this.errorMessage = "Не удалось отключить автоплатеж";
      }).finally(() => {
        this.isActionLoading = false;
      });
    }
  },
  mounted() {
    this.fetchStatus();
  }
}
</script>

<style scoped>
.autopayment-page {
  height: 100%;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  text-align: center;
}

.autopayment-icon {
  width: 100px;
  height: 100px;
  color: #0082bf;
}

.autopayment-icon svg {
  width: 100%;
  height: 100%;
}

.autopayment-title {
  font-family: "Mont", serif;
  font-weight: 700;
  font-size: 1.3rem;
  color: #0082bf;
  margin: 0;
}

.autopayment-subtitle {
  font-family: "Mont", serif;
  font-size: 1rem;
  color: #0082bf;
  margin: 0;
}

.autopayment-action {
  border: none;
  border-radius: 16px;
  padding: 12px 24px;
  font-family: "Mont", serif;
  font-weight: 600;
  font-size: 1rem;
  color: #ffffff;
  background: #0082bf;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.autopayment-action:hover {
  opacity: 0.9;
}

.autopayment-action:active {
  transform: translateY(1px);
}

.autopayment-action[disabled] {
  opacity: 0.6;
  cursor: default;
  transform: none;
}
</style>
